import React from "react";
import { Link } from "react-router-dom";
import { Heart, Stethoscope, CalendarHeart, Baby, ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import { Overline, SectionHeading, CTABand } from "@/components/blocks";
import { ASSETS } from "@/data/site";

const CARE = [
  { icon: Stethoscope, t: "Antenatal Care", d: "Regular check-ups and monitoring to support a healthy pregnancy." },
  { icon: Heart, t: "Personalised Monitoring", d: "Guidance tailored to your pregnancy, at every trimester." },
  { icon: Baby, t: "Maternity Guidance", d: "Support and preparation as you approach the arrival of your baby." },
  { icon: CalendarHeart, t: "Postpartum Support", d: "Compassionate care during recovery and early motherhood." },
];

export default function PregnancyCare() {
  return (
    <div>
      <SEO title="Pregnancy & Maternity Care | Dr. Mithee's Clinic, Noida" path="/pregnancy-care" description="Personalised antenatal care, pregnancy monitoring, maternity guidance and postpartum support at Dr. Mithee's Clinic for Women in Noida." />

      <section className="bg-gradient-to-b from-blush to-background pt-28 md:pt-36">
        <div className="container-clinic grid items-center gap-14 pb-20 md:grid-cols-2">
          <Reveal>
            <Overline>Pregnancy & Maternity</Overline>
            <h1 className="mt-4 font-serif text-4xl leading-tight tracking-tight text-charcoal sm:text-5xl">Gentle guidance through your pregnancy journey</h1>
            <p className="mt-6 text-base leading-relaxed text-taupe">
              Pregnancy is a profound chapter. With over 25 years of experience, Dr. Mithee offers attentive, personalised care — walking alongside you from your first appointment through to the joyful arrival of your baby and beyond.
            </p>
            <Link to="/appointment" data-testid="pregnancy-book-btn" className="mt-8 inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 font-sans text-sm font-semibold text-cream transition-colors hover:bg-terracotta-dark">
              Book an Appointment <ArrowRight className="h-4 w-4" />
            </Link>
          </Reveal>
          <Reveal delay={120} className="relative">
            <div className="absolute -inset-4 rounded-tr-[5rem] rounded-bl-[5rem] bg-rose/20" aria-hidden="true" />
            <img src={ASSETS.maternity} alt="Elegant maternity care" className="relative w-full rounded-tr-[5rem] rounded-bl-[5rem] object-cover shadow-lift" />
          </Reveal>
        </div>
      </section>

      <section className="container-clinic py-20 md:py-28">
        <Reveal><SectionHeading overline="What's Included" title="Care through every trimester" /></Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2">
          {CARE.map((c, i) => (
            <Reveal key={c.t} delay={(i % 2) * 90}>
              <div className="flex gap-5 rounded-3xl border border-soft-border bg-cream p-8">
                <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-blush text-terracotta"><c.icon className="h-5 w-5" /></span>
                <div>
                  <h3 className="font-serif text-xl text-charcoal">{c.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-taupe">{c.d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand />
    </div>
  );
}
